import {createContext} from 'react';
import commonStyles from './common.module.scss';
import {IEventCommonContext} from './type';

export const ANIMATE_ITEM_CN = commonStyles.animateItem;
export const ANIMATE_ITEM_TOP_IMAGE_CN = commonStyles.topImage;
export const ANIMATE_ACTIVE_CN = commonStyles.active;

export const MISSION_PRE_ATTENDANCE_FETCH_KEY = -1;
export const MISSION_CONTENT_RESERVATION_FETCH_KEY = -2;

export const EVENT_TOP_HEIGHT = 480;
export const EVENT_TOP_HEIGHT_CN = 'h-[480px]';
export const EVENT_TOP_GRADIENT_BOX_CN =
  'absolute inset-x-0 bottom-0 h-[180px]';
export const EVENT_MAX_WIDTH_272_CN = 'max-w-[272px]';

export const EventCommonContext = createContext<IEventCommonContext>({
  eventType: 'event',
});
export const IsUnionModuleContext = createContext(false);
